import set from "@rill/set";
import rill from "rill";

import getIncomes from "./income.controller.js";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions.js";

const Income = (app) => {
  app.at(
    "/income/*",
    rill()
      .use(set("heading", ["Coaching", "Incomes"]))
      .setup((app) => {
        app.get(
          "/",
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["PUSH"],
              "/coaching-portal/athletes",
              ["Admin", "Owner"]
            ),
          getIncomes
        );
      })
  );
};

export default Income;
